import { Action } from './action';
import { Menu } from 'acscp/store';

export class SetOpenMenu extends Action {
    constructor(public menu: Menu | undefined) {
        super();
    }
}
